import classNames from 'classnames'
import styles from './Banner.module.scss'
import type { BannerProps } from './types'
import { BannerStyle } from './types'

const Banner = ({
  className,
  title,
  description,
  style = BannerStyle.neutral,
  link: LinkComponent,
  accessory,
}: BannerProps) => {
  const Accessory = accessory
  return (
    <div data-style={style} className={classNames(styles['pintxo-banner'], className)}>
      {Accessory && <div className={styles['pintxo-banner__accessory']}>{Accessory}</div>}
      <div className={styles['pintxo-banner__content']}>
        {title && <p className={styles['pintxo-banner__content__title']}>{title}</p>}
        {description && (
          <p className={styles['pintxo-banner__content__description']}>{description}</p>
        )}
        {LinkComponent && <p className={styles['pintxo-banner__content__link']}>{LinkComponent}</p>}
      </div>
    </div>
  )
}

export default Banner
